import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Table,
  Avatar,
  Row,
  Col,
  message,
  Popover,
  Popconfirm,
  Tag,
  Badge,
} from 'antd'
import {
  DeleteFilled,
  DownloadOutlined,
  InfoCircleFilled,
  MailFilled,
  QrcodeOutlined,
} from '@ant-design/icons'
import util from '../../util/util'
import '../../css/patient.scss'
import { useHistory, Redirect } from 'react-router'
import {
  deleteMessages,
  getMessageList,
  messageRowSelect,
} from '../../store/action/callback.action'
import moment from 'moment'
import download from '../../images/download.svg'
import upload from '../../images/upload.svg'
import atrchivesvg from '../../images/archive.svg'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { constants } from '../../constants'
import {
  fechactioncase,
  deleteActionCase,
  isNewActionCase,
  updateLastViewed,
} from '../../store/action/actioncases.action'
import { messageScope } from '../../util/messagefilter'

const Messages = (props) => {
  var history = useHistory()
  console.log(history.location.state, 'LOCATION', props.pagination?.pageSize)
  let filter = {}
  useEffect(() => {
    // var filter = {};
    var def = false
    if (history.location.state?.status)
      filter.status = [history.location.state?.status]
    if (history.location.state?.filters?.caseNumbers)
      filter.caseNumbers = history.location.state?.filters.caseNumbers
    if (history.location.state?.customerid)
      filter.customerIds = [history.location.state?.customerid]
    
    if (props?.decoded?.customer) {
      filter.customerIds = [props.decoded.customer]
    }
    filter.archived = false
    
    const isSurgeon = props.user?.role == constants.ROLE.SURGEON
    const isMedicalAssociate = props.user?.role == constants.ROLE.MEDICAL_ASSOCIATE
    const hasSurgeonId = !!props.user?.surgeon
    
    if (isSurgeon || isMedicalAssociate || hasSurgeonId) {
      filter.surgeonId = props.user?.surgeon
    }
    filter = { ...filter, ...props.msgfilter }
    // Always enforce the open customer + message-type scope (defaults to both).
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    // if (Object.keys(filter).length === 0 && filter.constructor === Object) {
    //   filter.status = [constants.ACTION_CASE_STATUS.ASSIGNED, constants.ACTION_CASE_STATUS.UNASSIGNED]
    // }
    if (props?.decoded?.customer) {
      props.isNewActionCase(props.decoded.customer)
    }
    if (props?.company?._id) {
      props.isNewActionCase(null, null, props?.company?._id)
    }

    const isCompanyRole = props.user?.role == constants.ROLE.COMPANY_ADMIN ||
                         props.user?.role == constants.ROLE.COMPANY_HEALTHCOACH
    const hasCustomer = !!(props?.customer?._id || props?.decoded?.customer)
    
    // Don't make query for company roles without customer selection
    if (isCompanyRole && !hasCustomer) {
      console.log('Skipping query - company role needs customer selection')
      return
    }

    props.fechactioncase(
      {
        metadata: { current: 1, pageSize: 20 },
        filters: !_.isEmpty(props.selectedIndex)
          ? { ...filter, surgeonId: props.selectedIndex }
          : filter,

        sorter: { field: 'lastUpdated', order: 'descend' },
      },
      null,
      false
    )
    //  props.getCaseStats(history.location.state?.customerid)
  }, [])

  var fetchMessages = (pagination, filters, sorter) => {
    props.fetchMessages(
      {
        ...props.filters,
        surgeonid:
          props.user.role == constants.ROLE.SURGEON
            ? props.user.surgeon
            : props.filters.surgeonid,
        customer: props.customer._id,
        sort: sorter,
        pagination,
      },
      props.selectedRequests
    )
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  // var dataSource = formatdata(props.requests);
  // var pagination = {
  //     ...props.pagination,
  //     showSizeChanger: true
  // };

  // var handleRowClick = (record, e) => {
  //     console.log("ROREWWWWW")
  //     e.stopPropagation();
  //     record.isOutsider && history.push({pathname: 'patient/'+record.patient?._id, state: record.patient});
  // }

  // var handleRow = (record, rowIndex) => {
  //     return {
  //         onClick: (e) =>  handleRowClick(record, e)
  //     }
  // }

  var handleRowClick = (record) => {
    
    const caseId = record.caseId
    
    if (!caseId) {
      return
    }
    props.updateLastViewed({ caseId: caseId })
    history.push({ pathname: 'cases/' + caseId })
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var handleInfo = (e, obj) => {
    e.stopPropagation()
    history.push({ pathname: 'patient/' + obj.patientId })
  }
  var renderPatientName = (name, obj) => {
    return (
      <Row className={'nameRow'} align='middle'>
        &nbsp;{name}&nbsp;
        <InfoCircleFilled
          onClick={(e) => handleInfo(e, obj)}
          className='infocircle'
        />
      </Row>
    )
  }
  var renderMessages = (message, obj) => {
    return (
      <>
      <div className='message-body-pre-summary'>{obj.summary}</div>
      <div className='message-body-pre'>
      {message} 
        {obj.isNew && (
          <>
            &nbsp;&nbsp;
            <Tag style={{ borderRadius: '50%' }} color='#d32f2f'>
              New
            </Tag>
          </>
        )}
      </div>
      </>

    )
  }
  const columns = [
    {
      title: 'Patient',
      dataIndex: 'patientName',
      //   sorter: true,
      width: '230px',
      render: (name, obj) => (name ? renderPatientName(name, obj) : 'NA'),
    },

    // {
    //   title: "Case#",
    //   dataIndex: "caseNumber",
    //   sorter: true,
    //   render:(caseno,obj)=>renderCaseNumber(caseno,obj),
    // },
    {
      title: 'Reported By ',
      dataIndex: 'reportedUsername',
      width: '230px',
      sorter: true,
    },
    {
      title: 'Received on',
      dataIndex: 'createdDate',
      defaultSortOrder: 'descend',
      width: '170px',
      sorter: true,
      render: (date) => {
        return date
          ? moment(date).format('MM/DD/YYYY, h:mm a').toString()
          : 'NA'
      },
    },
    {
      title: 'Message',
      dataIndex: 'description',
      render: (name, obj) => (name ? renderMessages(name, obj) : 'NA'),
      // width: "800px",
    },
    // {
    //   title: "Patient",
    //   dataIndex: "patientLastDigitOfPhone",
    //   render: (record) => record ? `XXXXX-X${record}` : 'N/A',
    // },
    // {
    //   title: "Last updated",
    //   dataIndex: "updatedDate",
    //   sorter: true,
    //   render: (date) => {
    //     return moment(date).format("MM/DD/YYYY, h:mm a").toString();
    //   },

    // },
    {
      title: 'Action',
      align: 'center',
      width: '200px',
      render: (row, obj) => (
        <Popconfirm
          title='Are you sure？'
          okText='Yes'
          cancelText='No'
          onConfirm={(e) => {
            e.stopPropagation()
            e.nativeEvent.stopImmediatePropagation()
            handleDelete([obj.caseId])
          }}
        >
          <img
            id={'messageaction'}
            onClick={(e) => e.stopPropagation()}
            width='26px'
            src={atrchivesvg}
          />
        </Popconfirm>
      ),
    },
  ]
  async function fetchActionCaseList(pagination, filters, sorter) {
    let filter = { ...props.msgfilter }
    if (props.groupby && props.selectedIndex) {
      filter = { ...filter, surgeonId: props.selectedIndex }
    }
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filter.surgeonId = props.user?.surgeon
    }
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    await props.fechactioncase(
      {
        metadata: pagination
          ? { current: pagination.current, pageSize: pagination.pageSize }
          : { current: 1, pageSize: 20 },
        filters: filter,
        sorter: {
          field: sorter.field ?? 'lastUpdated',
          order: sorter.order ?? 'descend',
        },
      },
      null,
      false
    )
  }

  const rowSelection = {
    selectedRowKeys: props.selectedRequests?.key
      ? props.selectedRequests.key
      : [],
    onChange: (key, row) =>
      props.onRowSelect({
        key,
        row: util.filterRows(row, key, props.selectedRequests),
      }),
  }

  var formatNumber = (phone) => {
    var number = phone?.toString()
    if (number) {
      if (number.length > 10)
        number = number?.charAt(0) == '+' ? number : '+' + number
      else number = number?.charAt(0) == '+' ? '1' + number : '+1' + number
      return number
    }
  }

  const handleDelete = (caseidArr) => {
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filter.surgeonId = props.user?.surgeon
    }
    filter = { ...filter, ...props.msgfilter }
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    props.deleteActionCase(caseidArr).then((res) => {
      props.fechactioncase({
        metadata: { current: 1, pageSize: 20 },
        filters: !_.isEmpty(props.selectedIndex)
          ? { ...filter, surgeonId: props.selectedIndex }
          : filter,
        sorter: { field: 'lastUpdated', order: 'descend' },
      })
    })
    // props.deleteMessages([obj._id])
    // .then(res => {
    //     if (res) {
    //         fetchMessages(
    //             {current: 1,pageSize: 20},
    //             // props.selectedRequests,
    //             {order: "descend", field: "receivedon"}
    //         );
    //     }
    // })
  }

  // const checkNew = (date, lastlogintime=props.user.lastlogintime) => {
  //     lastlogintime = props.showSurgs ? props.user.lastlogintime : lastlogintime;
  //     return moment(moment.utc(date).toDate())
  //         .local()
  //         .isAfter(moment(moment.utc(lastlogintime).toDate())
  //         .local())
  // }

  var renderSurgeon = (surgeon, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={surgeon?.image}>{surgeon?.name[0]?.toUpperCase()}</Avatar>
        {/* <Badge count={obj.isNew?1:0} size='small'style={{fontSize:10}}> */}
        <Row>{_.upperFirst(surgeon?.name)}</Row>
        {/* </Badge> */}
      </Row>
    )
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'} align='middle'>
        {/* <img height="26px" src={obj.isOutsider ? download : upload} /> */}
        <QrcodeOutlined
          hidden={obj.isOutsider}
          title='patient not registered'
        />
        &nbsp;{name}&nbsp;
        <Popover
          overlayClassName='info-pop'
          trigger='click'
          content={
            <Col
              flex='auto'
              style={{ padding: 8, borderRadius: 5, width: 250 }}
            >
              <Row>
                <Col flex='50px'>Name</Col>
                <Col>: &nbsp;{name}</Col>
              </Row>
              <Row>
                <Col flex='50px'>Phone</Col>
                <Col>
                  : &nbsp;{formatPhoneNumberIntl(formatNumber(obj?.phone))}
                </Col>
              </Row>
              <Row hidden={!obj.patient}>
                <Col flex='50px'>Surgery </Col>
                <Col>
                  : &nbsp;{' '}
                  {moment(obj?.patient?.surgery?.date).format('MM/DD/YYYY')}
                </Col>
              </Row>
            </Col>
          }
        >
          <InfoCircleFilled />
        </Popover>
        {/* { checkNew(obj.receivedon, obj.surgeon.lastlogintime) &&<>
                    &nbsp;&nbsp;<Tag style={{borderRadius: '50%'}} color="#d32f2f">New</Tag>
                </> } */}
      </Row>
    )
  }

  // const columns = [
  //     {
  //         title: 'From',
  //         dataIndex: 'from',
  //         width: "230px",
  //         render: (name, obj) => renderName(name, obj),
  //     },
  //     {
  //         title: 'Received on',
  //         dataIndex: 'receivedon',
  //         defaultSortOrder: 'descend',
  //         width: "170px",
  //         sorter: true,
  //         render: (date) => moment(moment.utc(date).toDate()).local().format("MM/DD/YYYY, h:mm a"),
  //     },
  //     {
  //         title: 'Message',
  //         dataIndex: 'message',
  //         // sorter: true,
  //     },
  //     {
  //         title: 'Action',
  //         align: 'center',
  //         render: (row, obj) => <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={(e) => {
  //             e.stopPropagation();
  //             e.nativeEvent.stopImmediatePropagation();
  //             handleDelete(obj)
  //         }}>
  //             <img onClick={(e) => e.stopPropagation()} width="26px" src={atrchivesvg}/>
  //         </Popconfirm>
  //     }
  // ];

  props.showSurgs &&
    columns.splice(1, 0, {
      title: 'Provider',
      dataIndex: 'surgeon',
      width: '300px',
      render: (surgeon, obj) => renderSurgeon(surgeon, obj),
    })
  var dataSource = formatdata(props.actioncases)

  const components = {
    table: (props) => <table {...props} />,
    header: {
      wrapper: (props) => <thead id='messageview' {...props} />,
    },
  }
  return (
    // <Table
    //     size={"large"}
    //     className={"custom-table"}
    //     columns={columns}
    //     dataSource={dataSource}
    //     loading={props.isLoading}
    //     pagination={pagination}
    //     rowSelection={rowSelection}
    //     onChange={fetchMessages}
    //     bordered={false}
    //     onRow={handleRow}
    // />
    <Table
      size={'large'}
      className={'custom-table'}
      columns={columns}
      dataSource={dataSource}
      loading={props.isLoading}
      rowSelection={rowSelection}
      pagination={{
        current: props.metaData?.current,
        pageSize: props.metaData?.pageSize,
        total: props.total,
        showSizeChanger: true,
      }}
      onChange={fetchActionCaseList}
      bordered={false}
      onRow={handleRow}
      components={components}
    />
  )
}

Messages.propTypes = {}

const mapStateToProps = (state) => {
  return {
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    user: state.profile.user,
    // pagination: state.message.pagination,
    requests: state.message.requests,
    isLoading: state.actioncase.isLoading,
    selectedRequests: state.message.selectedRequests,
    sort: state.message.sort,
    actioncases: state.actioncase.actioncases,
    searchText: state.actioncase.searchText,
    metaData: state.actioncase.metadata,
    sorter: state.actioncase.sorter,
    filters: state.actioncase.filters,
    // pagination: state.actioncase.pagination,
    selectedIndex: state.message.selectedIndex,
    msgfilter: state.message.filter,
    groupby: state.message.groupby,
    total: state.actioncase.total,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // fetchMessages: (filter, selected) => dispatch(getMessageList(filter, selected)),
    onRowSelect: (rows) => dispatch(messageRowSelect(rows)),
    deleteMessages: (ids) => dispatch(deleteMessages(ids)),
    fechactioncase: (params) => dispatch(fechactioncase(params)),
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
    deleteActionCase: (ids) => dispatch(deleteActionCase(ids)),
    updateLastViewed: (params) => dispatch(updateLastViewed(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Messages)
